import React from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { Box, Typography, Button, Grid } from '@mui/material';
import { TextInputFormField } from '../../../../Shared/TextInputFormField';
import ProgressBar from '../../../../Shared/ProgressBar';
import { ReactComponent as AdminIcon } from '../../../../../images/icons/assign_user.svg';
import { textFieldStyles } from '../../../../../mainTheme';

const adminValidationSchema = Yup.object({
  first_name: Yup.string()
    .matches(
      /^[A-Za-z ]+$/,
      'First name must contain only alphabetical characters',
    )
    .required('First name is required'),
  last_name: Yup.string()
    .matches(
      /^[A-Za-z ]+$/,
      'Last name must contain only alphabetical characters',
    )
    .required('Last name is required'),
  email: Yup.string().email('Invalid email').required('Email is required'),
});

interface AdminInviteFormProps {
  onSubmit: (values: any) => void;
  onBack: () => void;
  actionType?: 'invite' | 'add';
  mode?: 'facility' | 'location';
  isFacilityAdmin?: boolean;
  submitLabel?: string;
  currentStep?: number;
}
export const AdminInviteForm = ({
  onSubmit,
  onBack,
  actionType = 'invite',
  mode = 'facility',
  isFacilityAdmin,
  submitLabel,
  currentStep,
}: AdminInviteFormProps) => {
  const entityLabel = mode === 'location' ? 'location' : 'facility';
  const titleText = {
    invite: `Invite new ${entityLabel} admin`,
    add: `Add new ${entityLabel} admin`,
  };

  return (
    <Formik
      initialValues={{
        first_name: '',
        last_name: '',
        email: '',
      }}
      validationSchema={adminValidationSchema}
      onSubmit={onSubmit}
    >
      {({ isSubmitting, isValid, dirty }) => (
        <Form>
          <Box display="flex" flexDirection="column" gap={2}>
            {!isFacilityAdmin && (
              <ProgressBar
                currentStep={currentStep ?? (actionType === 'invite' ? 2 : 1)}
                totalSteps={2}
              />
            )}
            <AdminIcon />
            <Typography>{titleText[actionType]}</Typography>{' '}
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Field
                  name="first_name"
                  label="First name"
                  component={TextInputFormField}
                  sx={textFieldStyles}
                />
              </Grid>
              <Grid item xs={6}>
                <Field
                  name="last_name"
                  label="Last name"
                  component={TextInputFormField}
                  sx={textFieldStyles}
                />
              </Grid>
            </Grid>
            <Field
              name="email"
              label="Email address"
              component={TextInputFormField}
              sx={textFieldStyles}
            />
            <Box
              sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}
            >
              <Button
                variant="text"
                color="secondary"
                onClick={onBack}
                sx={{
                  textAlign: 'center',
                  fontSize: '14px',
                  fontWeight: 700,
                  lineHeight: '18px',
                  letterSpacing: '0.2px',
                  height: '44px',
                  width: '180px',
                }}
              >
                Back
              </Button>
              <Button
                variant="contained"
                color="secondary"
                type="submit"
                disabled={isSubmitting || !isValid || !dirty}
                sx={{
                  textAlign: 'center',
                  fontSize: '14px',
                  fontWeight: 700,
                  lineHeight: '18px',
                  letterSpacing: '0.2px',
                  height: '44px',
                  width: '180px',
                }}
              >
                {submitLabel ?? (actionType === 'invite' ? 'Invite' : 'Next')}
              </Button>
            </Box>
          </Box>
        </Form>
      )}
    </Formik>
  );
};
